import React, { useEffect } from 'react'
import Dashboard from "./Dashboard";
import {
    kidList,
    setKidList,
    setDashboardLoader,
    getLatestActivity,
    setLatestActivityData
} from '../../AxiosRtk/DashBoard';
import { useDispatch, useSelector } from 'react-redux';

const DashboardWrapper = () => {
    const { selectedDeviceData } = useSelector(({dashboard}) => dashboard);
    const dispatch = useDispatch();
    useEffect(() => {
        kidList()
            .then((res) => {
                dispatch(setKidList(res?.data?.result));
            })
            .catch((err) => {
                console.log("kid list catch error ==>>", err?.response?.data?.message);
            })
            .finally(() => {
                dispatch(setDashboardLoader(false));
            })
    }, [])


    useEffect(() => {
        if (selectedDeviceData) {
            getLatestActivity({ deviceId: selectedDeviceData?.ID })
                .then((res) => {
                    dispatch(setLatestActivityData(res?.data?.result))
                })
                .catch((err) => {
                    console.log("getting latest activity catch error ==>>", err?.response?.data?.message)
                })
        } else {
            dispatch(setLatestActivityData(null))
        }
    }, [selectedDeviceData])

    return <Dashboard />
}

export default DashboardWrapper